"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment, useEffect, useState } from "react";
import HeaderLink from "../header-link/header-link";
import css from "./header-links.module.scss";
import { TrustBar } from "@/sanity/sanity.types";
import imageUrl from "@/sanity/utilities/imageUrl";
import { getTrackingInfo } from "@/components/amc-pixel/amc-pixel-utils";
import { formatPhone } from "@/utilities/formatPhoneNumber";
interface IHeaderLinksProps {
  data: TrustBar;
  className?: string;
  numberOfLinksToShow?: number;
  showText?: boolean;
}
const HeaderLinks = props => {
  const $ = _c(10);
  const {
    className,
    data,
    numberOfLinksToShow,
    showText: t0
  } = props;
  const showText = t0 === undefined ? true : t0;
  const [trackingInfo, setTrackingInfo] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const fetchTrackingInfo = async () => {
        const info = await getTrackingInfo();
        setTrackingInfo(info);
      };
      fetchTrackingInfo();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = `${css.headerLinks} ${className ?? ""}`;
  let t4;
  if ($[2] !== data.badges || $[3] !== numberOfLinksToShow || $[4] !== showText || $[5] !== trackingInfo) {
    t4 = data.badges?.map((item, index) => {
      if (!item.link || !item.link.label || !item.link.href || !item.image?.asset || numberOfLinksToShow !== undefined && index >= numberOfLinksToShow) {
        return null;
      }
      const label = index === 0 && trackingInfo?.phone ? formatPhone(trackingInfo.phone) : item.link.label;
      const url = index === 0 && trackingInfo?.phone ? `tel:${trackingInfo.phone.replace(/\D/g, "")}` : item.link.href;
      return <Fragment key={index}>{index !== 0 && <span>|</span>}<HeaderLink icon={imageUrl(item.image?.asset).url()} label={showText ? label : ""} url={url} ctaId={item?.link?.ctaId ?? ""} ctaValue={item?.link?.ctaValue ?? ""} relValue={item?.link?.nofollow} /></Fragment>;
    });
    $[2] = data.badges;
    $[3] = numberOfLinksToShow;
    $[4] = showText;
    $[5] = trackingInfo;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default HeaderLinks;